import {comparator} from "../decorators/comparator.decorator";
import {Comparator} from "./comparator.interface";

@comparator()
export class DefaultComparator implements Comparator<any> {

    isEqualTo(value1: any, value2: any): boolean {
        return value1 === value2;
    }

}